module.exports = __webpack_public_path__ + "img/154.180be64a.png";